import { Campaigns } from 'pages/campaigns/campaigns';

export default function CampaignsPage() {
  return <Campaigns />;
}
